import { CompilationTargetId } from "../../types/CompilationTargetId";

export function getCompilationTargetString() {
    return CompilationTargetId.es6.toString();
}